import React from 'react';
import { Mouvement, Sens } from '@mairistem/comptabilite';
import PeriodeCouverteComponent from '../../../components/Mouvement/Panel/PeriodeCouverteComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class PeriodeCouvertePanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.PERIODE_COUVERTE;
    this.icon = { name: 'map signs' };
    this.defaultSize = 6;
  }

  getLibelle = (sens: string) => `Période couverte par ${(sens === Sens.RECETTE) ? 'le produit' : 'la charge'}`;

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.dateDebutCharge || ligne?.dateFinCharge);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
    sens: string,
  ): React.ReactElement {
    return (
      <PeriodeCouverteComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
        sens={sens}
      />
    );
  };
}

export default PeriodeCouvertePanel;
